import React, { useState } from 'react';
import { Container, Form, InputGroup } from 'react-bootstrap';
import { AiOutlineMail, AiOutlineUser } from 'react-icons/ai';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-hot-toast';
import { useEffect } from 'react';
import Loader from '../common/Loader';
import { clearErrors, getUserDetails, updateUser } from '../../redux/actions/userAction';
import MetaData from '../MetaData';
import { Row, Col } from 'react-bootstrap';
import Sidebar from './Sidebar';
import { UPDATE_USER_RESET } from '../../redux/constants/userConstants';

const UpdateUser = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const { loading, error, user } = useSelector((state) => state.userDetails);
    const {
        loading: updateLoading,
        error: updateError,
        isUpdated,
    } = useSelector((state) => state.profile);

    const [userDetails, setUserDetails] = useState({
        name: '',
        email: '',
        role: '',
    });

    useEffect(() => {
        if (!user || user._id !== id) {
            dispatch(getUserDetails(id));
        } else {
            setUserDetails({
                name: user.name,
                email: user.email,
                role: user.role,
            });
        }

        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }
        if (updateError) {
            toast.error(error);
            dispatch(clearErrors());
        }
        if (isUpdated) {
            toast.success('USer Updated successfully');
            navigate('/admin/users');
            dispatch({ type: UPDATE_USER_RESET });
        }
    }, [error, dispatch, isUpdated, updateError, user, id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(updateUser(id, userDetails));
    };

    const handleInputChange = (e) => {
        setUserDetails({ ...userDetails, [e.target.name]: e.target.value });
    };

    return (
        <>
            <MetaData title={'Update User - Admin'} />
            <Container>
                <div className='myOrdersPage section-padding-top section-padding-bottom'>
                    <Row>
                        <Col md={3}>
                            <Sidebar />
                        </Col>
                        <Col md={9}>
                            {loading ? (
                                <Loader />
                            ) : (
                                <form onSubmit={handleSubmit} className='createProductForm'>
                                    <h4 className='text-center mb-4 formHeading'>Update User</h4>
                                    <InputGroup className='mb-3'>
                                        <InputGroup.Text id='basic-addon1'>
                                            <AiOutlineUser />
                                        </InputGroup.Text>
                                        <Form.Control
                                            placeholder='Name'
                                            aria-label='Name'
                                            name='name'
                                            type='text'
                                            value={userDetails.name}
                                            onChange={handleInputChange}
                                        />
                                    </InputGroup>
                                    <InputGroup className='mb-3'>
                                        <InputGroup.Text id='basic-addon1'>
                                            <AiOutlineMail />
                                        </InputGroup.Text>
                                        <Form.Control
                                            placeholder='Email'
                                            aria-label='Email'
                                            name='email'
                                            type='email'
                                            value={userDetails.email}
                                            onChange={handleInputChange}
                                        />
                                    </InputGroup>
                                    <InputGroup className='mb-3 align-items-center'>
                                        <InputGroup.Text id='basic-addon1'>
                                            <AiOutlineMail />
                                        </InputGroup.Text>
                                        <input
                                            className='form-check-input ms-4'
                                            type='radio'
                                            name='role'
                                            id='role1'
                                            checked={userDetails.role.toLowerCase() === 'admin'}
                                            onChange={(e) =>
                                                setUserDetails({ ...userDetails, role: 'admin' })
                                            }
                                        />
                                        <label className='form-check-label ms-2' for='role1'>
                                            Admin
                                        </label>
                                        <input
                                            className='form-check-input ms-4'
                                            type='radio'
                                            name='role'
                                            id='role2'
                                            checked={userDetails.role.toLowerCase() === 'user'}
                                            onChange={(e) =>
                                                setUserDetails({ ...userDetails, role: 'user' })
                                            }
                                        />
                                        <label className='form-check-label ms-2' for='role2'>
                                            User
                                        </label>
                                    </InputGroup>
                                    <input
                                        type='submit'
                                        value='Update'
                                        className='submitBtn'
                                        disabled={
                                            updateLoading || userDetails.role === '' ? true : false
                                        }
                                    />
                                </form>
                            )}
                        </Col>
                    </Row>
                </div>
            </Container>
        </>
    );
};

export default UpdateUser;
